module.exports = __webpack_public_path__ + "static/media/1.d5d3d037.jpg";